import { v4 as uuidv4 } from 'uuid';

export function TabListItem(props = {}, childrenComponents = []) {
	return {
		componentName: 'TabListItem',
		componentId: uuidv4(),
		props: Object.assign(
			{
				label: 'Tab',
			},
			props,
		),
		childrenComponents,
	};
}
